var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path, _g25, _g26, _g27, _g28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bars-progress"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "timeline"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "timer"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle-vertical-history"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-plus-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,9c-6.075,-0 -11,4.925 -11,11c-0,6.075 4.925,11 11,11c6.075,-0 11,-4.925 11,-11c-0.007,-6.072 -4.928,-10.993 -10.999,-11l-0.001,-0Zm-0,20.308c-5.14,-0 -9.308,-4.168 -9.308,-9.308c0,-5.14 4.168,-9.308 9.308,-9.308c5.14,0 9.308,4.168 9.308,9.308c-0.006,5.138 -4.17,9.302 -9.307,9.308l-0.001,-0Zm5.077,-9.308c-0,0.467 -0.379,0.846 -0.846,0.846l-3.385,0l0,3.385c0,0.467 -0.379,0.846 -0.846,0.846c-0.467,-0 -0.846,-0.379 -0.846,-0.846l-0,-3.385l-3.385,0c-0.467,0 -0.846,-0.379 -0.846,-0.846c0,-0.467 0.379,-0.846 0.846,-0.846l3.385,-0l-0,-3.385c-0,-0.467 0.379,-0.846 0.846,-0.846c0.467,0 0.846,0.379 0.846,0.846l0,3.385l3.385,-0c0.467,-0 0.846,0.379 0.846,0.846Z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "list-timeline"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "clock-history"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRPlus);
export default __webpack_public_path__ + "static/media/iconR-plus.47a2bf04d1b5458d05f0aa49f0db5205.svg";
export { ForwardRef as ReactComponent };